import { render, staticRenderFns } from "./CompetitionFixtures.vue?vue&type=template&id=19ec7af9&scoped=true"
import script from "./CompetitionFixtures.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitionFixtures.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompetitionFixtures.vue?vue&type=style&index=0&id=19ec7af9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec7af9",
  null
  
)

export default component.exports